var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThemeDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4058",
    "data-name": "Group 4058",
    transform: "translate(-548 -770)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3879",
    "data-name": "Group 3879",
    transform: "translate(552 774)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8694",
    "data-name": "Path 8694",
    d: "M12.514,12.673A7.773,7.773,0,0,1,6.046,1.611a.425.425,0,0,0-.582-.559A8.48,8.48,0,1,0,16.948,12.536a.425.425,0,0,0-.559-.582A7.751,7.751,0,0,1,12.514,12.673Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#16161a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemeDark);
export default __webpack_public_path__ + "static/media/theme-dark.77125eb47cd65de925fe61d380642e6f.svg";
export { ForwardRef as ReactComponent };